export default class TicketService {

    $api;
    key = 'ticket';

    constructor(api) {
        this.$api = api;
    }

    get() {
        return sessionStorage.getItem(this.key);
    }

    store(ticket) {
        sessionStorage.setItem(this.key, ticket);
    }

    remove() {
        sessionStorage.removeItem(this.key);
    }

    exists() {
        return this.get() !== null;
    }

    ticketValid() {
        return this.application()
            .then(
                () => Promise.resolve(true)
            )
            .catch(
                () => {
                    this.remove();
                    return Promise.reject(false)
                }
            );
    }

    application() {
        return this.exists() ?
            this.$api.get(`/tickets/${this.get()}`)
                .then(response => response.data.application)
                .catch(() => Promise.reject()) :
            Promise.reject();
    }

    send(session, resource, adminMode, pinSwitch) {
        return this.$api.post(
            `/tickets/${this.get()}/resource`,
            {
                login: session,
                user: resource,
                admin: adminMode,
                'pin-switch': pinSwitch,
            }
        ).then(response => {
            this.remove();
            return response.data.redirect
        }).catch(() => Promise.reject());
    }

}
